import React from 'react';
import { bytesToFormattedSize } from 'utils/utils';

const SizeTemplate = ({ rowData }) => {
  return (
    <>
      <span className="p-column-title text-break">Size</span>
      <span className="text-muted">
        {rowData?.entry_type === 'folder' || typeof rowData?.size === 'undefined' || rowData?.size === null
          ? '-'
          : bytesToFormattedSize(rowData.size)}
      </span>
    </>
  );
};

export default SizeTemplate;
